/** @module Apparel/DesignatedSupplierMixin */
define([
	"dojo/_base/declare",
	"csi/comm",
	"csi/def",
	"csi/xml"
], function (declare, comm, def, xml) {

	const DPS_PATH = xml.path("ProductSourcing", "DesignatedProductSource", "Supplier");
	const DPS_PATH_FDD = xml.path("ProductSourcing", "DesignatedProductSource", "SupplierFactory");

	return declare(null, {

		/**
		 * @override
		 * Ensure that the SupplierFactory is in the cache
		 */
		onDependencyPaths: function (paths) {
			paths.push(DPS_PATH_FDD);
		},

		/**
		 * Adding the Dependency Path for the Designated ProductSource's Supplier.  The parent can either be a product
		 * or a product Sourcing, so make sure have the right starting place for the path
		 * @param {Request[]} requests
		 */
		_preActionRequests: function (requests) {
			const parent = this.getParent();
			const urlProduct = parent.$Type.endsWith("Sourcing") ? parent.__Parent__ : parent.$URL;
			requests.push(comm.getNodeRequest(urlProduct).addDependencyPaths([DPS_PATH]));
			this.inherited(arguments);
		},

		/**
		 * Initializes the Designated ProductSource's Supplier as the preferred Supplier
		 * @param {Widget} view
		 * @param {String} fieldName
		 * @param {Boolean} isFDDEnabled
		 */
		initializeDPS: function (view, fieldName, isFDDEnabled = false) {
			var parent = this.getParent();
			if (parent && (parent.$Type == "Material" || parent.$Type == "Style" || parent.$Type == "Food" || parent.$Type == "FormulatedMaterial")) {
				this.initializeDPSForQuotes(view, fieldName, parent, isFDDEnabled);
			}
		},

		/**
		 * Initializes the Designated ProductSource's Supplier as the preferred Supplier
		 * @param {Widget} view
		 * @param {String} fieldName
		 * @param {Node} product
		 * @param {Boolean} isFDDEnabled
		 */
		initializeDPSForQuotes: function (view, fieldName, product, isFDDEnabled = false) {
			const dpsPathToUse = isFDDEnabled ? DPS_PATH_FDD : DPS_PATH;
			const dps = this.getCache().getPathNode(product, dpsPathToUse);
			const fieldTypeControl = view.getField(fieldName)?.m_typeControl;

			// make sure the Designated ProductSource's Supplier is visible
			if (dps) {
				view.addDefaultValue(fieldName, fieldTypeControl === def.FIELD_MULTI_SELECT ? [dps.$URL] : dps.$URL);
			}
		},
	});
});
